<template>
    <div :class="lightMood ? 'q-containerCopy' : 'q-container'">
        <div class="d-flex justify-content-between add-weight-section">
            <QuestionWeight :template="template" type="multipleChoices"/>
            <!-- <span @click="clearHandler" class="reset-data-btn">Reset All</span> -->
        </div>
        <div v-for="(q, idx) in template.questions.multipleChoices.questions"
             :key="idx"
             class="t-f-q-body q-body d-flex  flex-column justify-content-start">
            <div class="d-flex gap-3">
                <div class="d-flex flex-column w-100 position-relative single-q-container">
                    <div class="d-flex">
                        <QuestionComponent class="w-100 question-container" :id="'m-q'+idx" :template="template" type="multipleChoices" :index="idx"
                                       :validationCB="multipleChoicesQuestionsValidation"/>
                        <div class="align-self-end"
                        v-if="(template.questions.multipleChoices.questions.length - 1) === idx">
                        <span class="add-question"
                            title="Add Question"
                            @click="addQuestionHandler($event, 'multipleChoices')">+</span>
                        </div>
                    </div>
                    

                    <div class="err w-75" v-if="q.errors['question'].length > 0">
                        <div v-for="msg in q.errors['question']" class="text-danger">{{msg}}</div>
                    </div>
                </div>

                
            </div>
            <p class="my-0">Answers</p>
            <div class="d-flex gap-3 my-3">
                <div class="w-100">
                    <div class="d-flex flex-wrap gap-2 answers-container">

                        <div v-for="(a,index) in q.answers" class="">
                            <div class="m-c-answer-container position-relative">
                                <div>

                                    <input @click="checkHandler($event, idx, index)" :id="idx+'-'+index"
                                           type="checkbox"
                                           :value="a.value" v-model="a.is_correct" class="form-check-input"/>

                                </div>
                                <input type="text" class="w-100"
                                       autocomplete="off"
                                       @input="answerTextChangeHandler($event, idx, index ,'multipleChoices')"
                                       :placeholder="a.key" v-model="a.value"/>

                                <span class="delete-answer-icon"
                                      v-if="q.answers.length > 2"
                                      @click="deleteAnswerHandler(idx, index, 'multipleChoices')">
                                        <font-awesome-icon :icon="['fas', 'times']" size="sm"/>
                                    </span>
                            </div>


                            <div class="err" v-if="q.errors['answers'].length > 0">
                                <div class="text-danger">{{q.errors['answers'][index]}}</div>
                            </div>
                        </div>

                    </div>
                    <div class="err" v-if="q.errors['general'].length > 0">
                        <div v-for="msg in q.errors['general']" class="text-danger">{{msg}}</div>
                    </div>
                </div>

                <div class="align-self-center"
                     v-if="((template.questions.multipleChoices.questions.length - 1) === idx) && q.answers.length < 6">
                        <span class="add-question"
                              title="Add Choice"
                              @click="addChooseHandler($event, idx ,'multipleChoices')">+</span>
                </div>

            </div>

        </div>
    </div>

    <ConfirmationModal v-if="confirmFlag" :message="confirmMsg" confirmBtn="Yes" cancleBtn="No"
                       @close-modal="confirmModalHandler($event)"/>

    <span v-if="lightMood"></span>

</template>

<script>
    import {toRef, ref, defineAsyncComponent, computed} from "vue";
    import increaseTemplateQuestions from "../../../helpers/increaseTemplateQuestionsCounter";
    import decreaseTemplateQuestions from "../../../helpers/decreaseTemplateQuestionsCounter";
    import QuestionWeight from "../../components/QuestionWeight";
    import QuestionComponent from "../../components/templateComponents/questionComponent";
    const ConfirmationModal = defineAsyncComponent(() =>
        import ('../../components/ConfirmationModal')
    );
    import qustionValidation from "../../../validation/qustionValidation";
    import {useStore} from "vuex";

    export default {
        name: 'app',
        components: {QuestionWeight, QuestionComponent, ConfirmationModal},
        props: {
            template: Object
        },
        setup(props, context) {
            const store = useStore();
            const confirmFlag = ref(false);
            const confirmMsg = ref('');
            const template = toRef(props, 'template');
            const lightMood = computed({
                get() {
                    return store.state.settings.isLightMood;
                },
            });

            const checkHandler = (e, qIdex, aIdx) => {
                let errors = null;
                let element = template.value.questions.multipleChoices.questions[qIdex];
                template.value.questions.multipleChoices.questions[qIdex].answers[aIdx].is_correct = !template.value.questions.multipleChoices.questions[qIdex].answers[aIdx].is_correct;

                errors = multipleChoicesQuestionsValidation(element);
                if (!errors)
                    increaseTemplateQuestions(template, 'multipleChoices');
                else
                    decreaseTemplateQuestions(template, 'multipleChoices');
            };

            const questionTextChangeHandler = (e, idx, type) => {
                let element = template.value.questions.multipleChoices.questions[idx];
                let errors = null;

                errors = multipleChoicesQuestionsValidation(element);
                console.log("questionTextChangeHandler ", errors)
                if (!errors)
                    increaseTemplateQuestions(template, 'multipleChoices');
                else
                    decreaseTemplateQuestions(template, 'multipleChoices');
            };

            const addQuestionHandler = (e, type) => {

                let length = template.value.questions[type].questions.length;
                let lastElement = template.value.questions[type].questions[length - 1];
                let isErrors = false;
                let question = null;


                isErrors = multipleChoicesQuestionsValidation(lastElement);

                console.log({isErrors})
                question = {
                    question: '',
                    answers: [
                        {
                            key: 'Choice',
                            value: '',
                            is_correct: false
                        },
                        {
                            key: 'Choice',
                            value: '',
                            is_correct: false
                        }
                    ],
                    isDelete: true,
                    errors: {
                        question: [],
                        answers: [],
                        general: []
                    }
                };


                if (!isErrors) {
                    addNewQuestionData(question, type)
                }

            };

            const confirmModalHandler = (e) => {
                confirmFlag.value = false;
                if (e) {
                    template.value.questions['multipleChoices'].questions  = [{
                        question: '',
                        answers: [
                            {
                                key: 'Choice',
                                value: '',
                                is_correct: false
                            },
                            {
                                key: 'Choice',
                                value: '',
                                is_correct: false
                            }
                        ],
                        isDelete: true,
                        errors: {
                            question: [],
                            answers: [],
                            general: []
                        }
                    }];
                    if (template.value.questions['multipleChoices'].counter > 0) {
                        template.value.questions['multipleChoices'].counter = 0;
                        template.value.questionsCount -= 1;
                    }
                    template.value.questions['multipleChoices'].isError = false;
                }
            };
            const clearHandler = () => {

                template.value.questions['multipleChoices'].weight = null;
                template.value.questions['multipleChoices']['errors']['weight']['isError'] = false;
                template.value.questions['multipleChoices']['errors']['weight']['message'] = '';
                if(template.value.questions['multipleChoices'].counter > 0 ||  template.value.questions['multipleChoices'].isError){
                    confirmFlag.value = true;
                    confirmMsg.value = 'Are you sure you want to reset data?';
                }

            };

            const answerTextChangeHandler = (e, qIdx, aIdx, type) => {
                let element = template.value.questions[type].questions[qIdx];
                let errors = null;

                errors = multipleChoicesQuestionsValidation(element);
                console.log({errors})
                if (!errors)
                    increaseTemplateQuestions(template, 'multipleChoices');
                else
                    decreaseTemplateQuestions(template, 'multipleChoices');
            };

            const addChooseHandler = (e, idx, type) => {
                let answersLength = template.value.questions[type].questions[idx].answers.length;
                let errors = null;
                let element = template.value.questions[type].questions[idx];
                if (answersLength < 6) {
                    template.value.questions[type].questions[idx].answers.push(
                        {
                            key: 'Choice',
                            value: '',
                            is_correct: false
                        }
                    )
                }

                errors = multipleChoicesQuestionsValidation(element);
                if (!errors)
                    increaseTemplateQuestions(template, 'multipleChoices');
                else
                    decreaseTemplateQuestions(template, 'multipleChoices');

            };

            const deleteQuestionHandler = (idx, type) => {

                let errors = null;
                let element = template.value.questions.multipleChoices.questions[idx];
                template.value.questions[type].questions.splice(idx, 1);
                errors = multipleChoicesQuestionsValidation(element);
                if (!errors)
                    decreaseTemplateQuestions(template, 'multipleChoices');
            };

            const deleteAnswerHandler = (idx, index, type) => {
                let errors = null;
                template.value.questions[type].questions[idx].answers.splice(index, 1);
                let element = template.value.questions[type].questions[idx];
                errors = multipleChoicesQuestionsValidation(element);
                if (!errors)
                    increaseTemplateQuestions(template, 'multipleChoices');
                else
                    decreaseTemplateQuestions(template, 'multipleChoices');
                if (template.value.questions[type].questions[idx].answers.length === 0) {
                    template.value.questions[type].questions[idx].errors['general'] = ['*Required'];
                }
            };

            const multipleChoicesQuestionsValidation = (element) => {

                let BreakException = {};
                let isErrors = {
                    question: false,
                    answers: false,
                    answersCount: 0
                };

                if (template.value.questions['multipleChoices'].weight === null){
                    template.value.questions['multipleChoices']['errors']['weight']['isError'] = true
                    template.value.questions['multipleChoices']['errors']['weight']['message'] = '*Required'
                }

                element.errors['answers'] = [];
                element.errors['question'] = [];
                element.errors['general'] = [];

                isErrors.question = qustionValidation(element);

                if (element.answers.length === 0) {
                    element.errors['general'] = ['*Required'];
                    isErrors.answers = true;
                } else if (element.answers.length > 7) {
                    element.errors['general'] = ["* too many, chooices must be less than 7"];
                    isErrors.answers = true;
                } else {
                    element.errors['general'] = [];
                    isErrors.answers = false;
                }

                element.answers.forEach((ans, idx) => {
                    if (ans.value !== '') {
                        element.errors['answers'][idx] = '';
                        isErrors.answers = false;
                    } else {
                        element.errors['answers'][idx] = '*Required';
                        isErrors.answers = true;

                    }
                });

                if (element.errors['general'].length === 0) {
                    try {
                        element.answers.forEach((ans) => {
                            if (ans.is_correct === true) {
                                element.errors['general'] = [];
                                isErrors.answers = false;
                                throw BreakException;
                            } else {
                                element.errors['general'] = ['* please select correct answer'];
                                isErrors.answers = true;
                            }
                        });
                    } catch (e) {
                        if (e !== BreakException) throw e;
                    }
                }

                isErrors.answersCount = 0;
                element.errors['answers'].forEach(ans => {
                    ans !== '' ? isErrors.answersCount += 1 : null
                });
                isErrors = (isErrors.answersCount > 0) || (element.errors['question'].length > 0) || (element.errors['general'].length > 0);
                template.value.questions['multipleChoices'].isError = isErrors;
                console.log({isErrors})
                return isErrors;
            };

            const addNewQuestionData = (question, type) => {
                template.value.questions[type].questions.push(
                    question
                )
            };

            const checkErrors = (idx) => {
                let retVale = true;
                let errors = template.value.questions.multipleChoices.questions[idx].errors;
                if (errors.question.length === 0 && errors.answers.length === 0) {
                    retVale = false;
                }
                return retVale;
            };

            return {
                template,
                confirmFlag,
                confirmMsg,
                lightMood: computed(() => store.state.settings.isLightMood),
                confirmModalHandler,
                checkHandler,
                addQuestionHandler,
                deleteQuestionHandler,
                multipleChoicesQuestionsValidation,
                addNewQuestionData,
                questionTextChangeHandler,
                deleteAnswerHandler,
                addChooseHandler,
                answerTextChangeHandler,
                clearHandler,
                decreaseTemplateQuestions,
                increaseTemplateQuestions,
                checkErrors
            }
        }
    }

</script>

<style scoped>

    .question-container{
        padding-right: 20px;
    }
    .form-check-input {
        border: 1px solid #e95626 !important;;
        background-color: transparent !important;
    }

    .form-check-input:checked {
        background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e") !important;
        border: 2px solid var(--border-color-data-table) !important;;
        background-color: #e95626 !important;
        box-shadow: 0 0 0 1px #e95626 !important;
    }

    .answers-container {
        min-height: 0;
        max-height: 100px;
        overflow-y: auto;
        padding: 10px 0;
        width: 100%;
    }

    .q-body {
        height: 225px;
    }
    .add-weight-section{
        margin-bottom: 20px;
    }
    .single-q-container {
        height: 115px;
    }

    .weight-style {
        background-color: transparent;
        border: 1px solid #39525C;
        border-radius: 4px;
        width: 86px;
        height: 32px;
        color: #FFF;
        padding: 10px;
    }

    .q-weight-container {
        width: 18%;
    }

    .q-container {
        overflow-y: auto;
        padding: 20px;
        margin-top: 0;
        background-color: #032A3A;
        border-radius: 0 0 10px 10px;
        height: 100%;
    }

    .q-containerCopy {
        overflow-y: auto;
        padding: 20px;
        margin-top: 0px;
        /*background-color: #032A3A;*/
        border-radius: 0 0 10px 10px;
        height: 100%;
    }

    .t-f-q-body {
        height: auto;
    }

    .q-input {
        background-color: transparent !important;
        border: 1px solid #39525C;
        border-radius: 4px;
        height: 65px;
        color: #FFF;
        padding: 10px;
    }

    .q-input:focus,
    .q-input:focus-visible {
        outline: 0;
    }

    .delete-answer-icon {
        position: absolute;
        top: -5px;
        right: -4px;
        display: flex;
        background-color: #E95626;
        border-radius: 50%;
        width: 15px;
        height: 15px;
        border: 1px solid #E95626;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: bold;
        color: #032a3a;
        cursor: pointer;
    }

    .add-question {
        font-size: 18px;
        font-weight: 500;
        cursor: pointer;
        color: #e65c00;
        border: 1px solid;
        border-radius: 50%;
        width: 25px;
        height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        margin-bottom: 10px;
    }

    .add-question:hover{
        background-color:  #e65c00;
        color: #032a3a;
    }

    .m-c-answer-container {
        width: 360px;
        border: 1px solid #39525C;
        border-radius: 8px;
        padding: 8px;
        display: flex;
        color: var(--main-color);
        gap: 4px;
    }

    .m-c-answer-container > input[type=text],
    .m-c-answer-container > input[type=text]:focus,
    .m-c-answer-container > input[type=text]:focus-visible {
        border: 0;
        color: var(--main-color);
        background-color: transparent;
        outline: 0;
    }

</style>